import { ItiString } from "../utils/iti-string";

const tokenKey = "token";
const refreshTokenKey = "refreshToken";
const tokenExpirationKey = "tokenExpiration";
const refreshTokenExpirationKey = "refreshTokenExpiration";

let _token: string | null;
let _refreshToken: string | null;
let _tokenExpiration: Date | null;

export const ItiTokenService = {
	hasToken() {
		return !ItiString.isNullOrWhiteSpace(this.getToken());
	},
	setToken(
		token: string,
		refreshToken: string,
		tokenExpiration: number,
		refreshTokenExpiration: number,
	) {
		return new Promise<boolean>((resolve, reject) => {
			try {
				window.localStorage.setItem(tokenKey, token);
				window.localStorage.setItem(refreshTokenKey, refreshToken);

				const now = new Date();
				const expirationDate = new Date(now.getTime() + tokenExpiration * 1000);
				window.localStorage.setItem(
					tokenExpirationKey,
					expirationDate.toISOString(),
				);

				const refreshExpirationDate = new Date(
					now.getTime() + refreshTokenExpiration * 1000,
				);
				window.localStorage.setItem(
					refreshTokenExpirationKey,
					refreshExpirationDate.toISOString(),
				);

				_token = null;
				_refreshToken = null;
				_tokenExpiration = null;
				resolve(true);
			} catch (error) {
				reject(error);
			}
		});
	},
	getToken() {
		if (!_token) {
			_token = window.localStorage.getItem(tokenKey) as string;
		}
		return _token;
	},
	getRefreshToken() {
		if (!_refreshToken) {
			_refreshToken = window.localStorage.getItem(refreshTokenKey) as string;
		}
		return _refreshToken;
	},
	clearToken() {
		window.localStorage.removeItem(tokenKey);
		window.localStorage.removeItem(refreshTokenKey);
		window.localStorage.removeItem(tokenExpirationKey);
		window.localStorage.removeItem(refreshTokenExpirationKey);
		_token = null;
	},
	getMillisecondsUntilExpiration() {
		if (!_tokenExpiration) {
			_tokenExpiration = new Date(
				window.localStorage.getItem(tokenExpirationKey) as string,
			);
		}
		const now = new Date();
		return _tokenExpiration.getTime() - now.getTime();
	},
	isTokenExpired() {
		return this.hasToken()
			? this.getMillisecondsUntilExpiration() < 3600
			: false;
	},
	isRefreshTokenExpired() {
		if (window.localStorage.getItem(refreshTokenExpirationKey)) {
			const now = new Date();
			const expiration = new Date(
				window.localStorage.getItem(refreshTokenExpirationKey) as string,
			);
			return expiration <= now;
		}
		return true;
	},
	areTokensExpired() {
		return this.isTokenExpired() && this.isRefreshTokenExpired();
	},
};
